import {
  loginAmrep,
  loginQRcode
} from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/cookie'

const login = {
  state: {
    token: getToken()
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    }
  },
  actions: {
    Login ({ commit }, data) {
      return new Promise((resolve, reject) => {
        loginAmrep(data).then(response => {
          if (response.code !== 200) {
            console.log(response.msg)
            reject(response.msg)
            return
          }
          setToken(response.result.token)
          commit('SET_TOKEN', response.result.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    LoginQRcode ({ commit }) {
      return new Promise((resolve, reject) => {
        loginQRcode().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetToken ({ commit }, token) {
      return new Promise((resolve, reject) => {
        setToken(token)
        commit('SET_TOKEN', token)
        resolve()
      })
    },
    LogOut ({ commit }) {
      return new Promise(resolve => {
        removeToken()
        commit('SET_TOKEN', '')
        resolve()
      })
    }
  }
}
export default login



// WEBPACK FOOTER //
// ./src/store/modules/login.js